export const GET_SUGGESTIONS = 'innovA/streets#getSuggestions';
export const LOADING_SUGGESTIONS = 'innovA/streets#loadingSuggestions';
export const CLEAR_SUGGESTIONS = 'innovA/streets#clearSuggestions';
export const CHECK_ZIP = 'innovA/streets#checkZip';
export const VALIDATE_CITY = 'innovA/streets#validateCity';
export const VALIDATE_ADDRESS = 'innovA/streets#validateAddress';